import React from 'react';
import Tool, { type ToolArgs } from '../../../tools/Tool';
import { Transforms, Editor, Element as SlateElement } from 'slate';
import { ReactEditor } from 'slate-react';
import classnames from 'classnames';
import styles from './LabelPillColor.module.css';
import { isLabelPillElement } from '../../../types/guards';

// Change the color schema of a label pill.
class ToolLabelPillColor extends Tool {
  static colorScheme: string = 'gray';

  static action({ editor, element }: ToolArgs): void {
    if (!element || !isLabelPillElement(element)) return;

    const path = ReactEditor.findPath(editor, element);
    Transforms.setNodes(
      editor,
      { pill_colorScheme: this.colorScheme },
      {
        at: path,
      }
    );
  }

  static isActive({ editor }: ToolArgs): boolean {
    if (!editor) return false;
    if (!editor.selection) return false;

    const [match] = Array.from(
      Editor.nodes(editor, {
        at: Editor.unhangRange(editor, editor.selection),
        match: (n) =>
          !Editor.isEditor(n) &&
          SlateElement.isElement(n) &&
          n.type === 'pill' &&
          n.pill_colorScheme === this.colorScheme,
      })
    );

    return !!match;
  }

  static renderToolbarButtonIcon({ editor, element }: ToolArgs): JSX.Element {
    return (
      <div
        className={classnames(styles.labelPillButton, styles[this.colorScheme])}
      />
    );
  }
}

class ToolLabelPillColorGray extends ToolLabelPillColor {
  static colorScheme: string = 'gray';
  static toolName = 'Gray';
}

class ToolLabelPillColorBlue extends ToolLabelPillColor {
  static colorScheme: string = 'blue';
  static toolName = 'Blue';
}

class ToolLabelPillColorGreen extends ToolLabelPillColor {
  static colorScheme: string = 'green';
  static toolName = 'Green';
}

class ToolLabelPillColorYellow extends ToolLabelPillColor {
  static colorScheme: string = 'yellow';
  static toolName = 'Yellow';
}

class ToolLabelPillColorRed extends ToolLabelPillColor {
  static colorScheme: string = 'red';
  static toolName = 'Red';
}
export {
  ToolLabelPillColorGray,
  ToolLabelPillColorBlue,
  ToolLabelPillColorGreen,
  ToolLabelPillColorYellow,
  ToolLabelPillColorRed,
};
